import { TaskType } from '@api';

export const isMarkReadEligible = (task: TaskType): boolean =>
  task.status === 'OPEN' && task.isUnread;
